import React from "react";
import { ShieldCheck, Target, BarChart3, Users } from "lucide-react";
import { C, Reveal } from "./shared";

const PROMISES = [
  { icon: ShieldCheck, label: "Verified Skills", sub: "build trust", color: C.navy },
  { icon: Target, label: "Better Matches", sub: "better outcomes", color: C.green },
  { icon: BarChart3, label: "Data-Driven", sub: "decisions", color: C.orange },
  { icon: Users, label: "Stronger Employability", sub: "& Placements", color: C.purple },
];

export default function PromiseBar() {
  return (
    <section className="border-y" style={{ borderColor: C.rule, background: C.paper }}>
      <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-2 md:grid-cols-4 gap-6">
        {PROMISES.map((p, i) => (
          <Reveal key={p.label} delay={(i % 4) + 1} className="group flex items-center gap-3 cursor-default" data-testid={`promise-${i}`}>
            <div className="w-11 h-11 rounded-lg grid place-items-center shrink-0 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3 group-hover:shadow-md"
              style={{ background: `${p.color}15`, color: p.color }}>
              <p.icon size={20} strokeWidth={2.2} />
            </div>
            <div className="leading-tight">
              <div className="font-bold text-sm transition-colors duration-300" style={{ color: C.ink }}>{p.label}</div>
              <div className="text-xs text-slate-500 transition-colors duration-300 group-hover:font-semibold">{p.sub}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
